var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41011 9H17.5901C17.7879 9.00083 17.981 9.06028 18.145 9.17085C18.3089 9.28141 18.4365 9.43811 18.5114 9.62115C18.5863 9.80418 18.6053 10.0053 18.5659 10.1991C18.5265 10.3929 18.4305 10.5707 18.2901 10.71L12.7101 16.29C12.6172 16.3837 12.5066 16.4581 12.3847 16.5089C12.2628 16.5596 12.1321 16.5858 12.0001 16.5858C11.8681 16.5858 11.7374 16.5596 11.6155 16.5089C11.4937 16.4581 11.3831 16.3837 11.2901 16.29L5.71011 10.71C5.56969 10.5707 5.47372 10.3929 5.43434 10.1991C5.39495 10.0053 5.41392 9.80418 5.48885 9.62115C5.56377 9.43811 5.69129 9.28141 5.85527 9.17085C6.01926 9.06028 6.21234 9.00083 6.41011 9Z",
    fill: "#374957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.61a95712463ef3076e9a1f6d41aa39a7.svg";
export { ForwardRef as ReactComponent };